import React from 'react'
import { Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import IdleTimer from 'react-idle-timer';
import SessionExpire from '../Components/Shared/SessionExpire';
import { successLoader, } from '../Redux/_actions/loader.action';
import store from '../Redux/_helpers/store';
import NotFound from './NotFound';
import { AES, enc } from 'crypto-js';
import Cookies from 'cookies-js';
import { connect } from 'react-redux';
// Home 
import Home from '../Components/Pages/Home/Home';
// ===========================================================================================
//Announcment and Notification
import Announcement from '../Components/Pages/Announcement/Announcement';
import AnnouncementDetails from '../Components/Pages/Announcement/AnnouncementDetails';
import AnnouncementSetting from '../Components/Pages/Announcement/AnnouncementSettings';
import Notification from '../Components/Pages/Announcement/Notification';
// ===========================================================================================
//Vessel and VesselDetails
import Vessel from '../Components/Pages/Vessel/Vessel';
import VesselDetail from '../Components/Pages/Vessel/VesselDetail';
// ===========================================================================================
//Weather Information
import WeatherInformation from '../Components/Pages/Weather/WeatherInformation';
// ===========================================================================================
// Container Status
import ContainerStatus from '../Components/Pages/ContainerStatus/ContainerStatus';
import ContainerStatusTripType from '../Components/Pages/ContainerStatus/ContainerStatusTripType';
import BillOfLading from '../Components/Pages/ContainerStatus/ContainerStatusBillOfLading';
import ContainerStatusView from '../Components/Pages/ContainerStatus/ContainerStatusView';
// ===========================================================================================
import AddProfile from '../Components/Pages/ProfileManagement/AddProfile';
import CompanyInfo from '../Components/Pages/ProfileManagement/CompanyInfo';
import BankInfo from '../Components/Pages/ProfileManagement/BankInfo';
import verifyMobile from '../Components/Pages/ProfileManagement/VerifyMobile';
import ViewProfile from '../Components/Pages/ProfileManagement/ViewProfile';
import DriverProfile from '../Components/Pages/ProfileManagement/DriverProfile';
// import ViewPdf from '../Components/Pages/Announcement/ViewPdf';
import ProfileActivity from '../Components/Pages/ProfileManagement/ProfileActivity';
// ===========================================================================================
//preferences
import preferencesRequester from '../Components/Pages/Preferences/RequesterPreferences'
import preferencesRespondent from '../Components/Pages/Preferences/RespondentPreference'
import preferencesDriver from '../Components/Pages/Preferences/DriverPreference'
//===========================================================================
// Subscription Fee
import ManageSubscription from '../Components/Pages/SubscriptionFee/ManageSubscription';
import BrowseAllPlans from '../Components/Pages/SubscriptionFee/BrowseAllPlans';
import paymentProcess from '../Components/Pages/SubscriptionFee/paymentProcess';
import PaymentDetails from '../Components/Pages/SubscriptionFee/PaymentDetails';
// ===========================================================================================
// Truck Appointment
import CreateAppointment from '../Components/Pages/TruckAppointment/CreateAppointment';
import AppointmentDetails from '../Components/Pages/TruckAppointment/AppointmentDetails';
import TruckAppointment from '../Components/Pages/TruckAppointment/TruckAppointment';
// ===========================================================================================
// Truck Visit
import TruckVisitsTrack from '../Components/Pages/TruckVisits/TruckVisitsTrack';
import TruckVisit from '../Components/Pages/TruckVisits/TruckVisit';
// ===========================================================================================
// pre advice
import PreAdviseHome from '../Components/Pages/PreAdvice/PreAdviseHome';
import PreAdvise from '../Components/Pages/PreAdvice/PreAdvise';
import PreadviseDetails from '../Components/Pages/PreAdvice/PreadviseDetails';
import PreadviseExcelDetails from '../Components/Pages/PreAdvice/PreadviseExcelDetails';
// for upload pre advice proxy file
import PreadviseProxy from '../Components/Pages/PreAdvice/PreadviseProxy';
import TrackHistoryforProxy from '../Components/Pages/PreAdvice/TrackHistoryforProxy';
import TrackMultipleContainer from '../Components/Pages/PreAdvice/TrackMultipleContainer';
import CreatePreadvise from '../Components/Pages/PreAdvice/CreatePreadvise';
import CreatePreadviseDetails from '../Components/Pages/PreAdvice/createPreAdviceDetails';
//add refeefer
import AddReefer from '../Components/Pages/PreAdvice/AddReefer';
// add hazard
import AddHazard from '../Components/Pages/PreAdvice/AddHazard';
import CreateAddHazard from '../Components/Pages/PreAdvice/CreateAddHazard';
import Placards from '../Components/Pages/PreAdvice/Placards';
// add OOG details
import OOGDetails from '../Components/Pages/PreAdvice/OOGDetails';
// for upload preadvice multiple file
import UploadPreadviseDocument from '../Components/Pages/PreAdvice/UploadPreadviseDocument';
// ===========================================================================================
// Customer Support
import ContactUs from '../Components/Pages/CustomerSupport/ContactUs';
import AllQueries from '../Components/Pages/CustomerSupport/AllQueries';
import QueryDetails from '../Components/Pages/CustomerSupport/QueryDetails';
import RaiseQuery from '../Components/Pages/CustomerSupport/RaiseQuery';
import FAQ from '../Components/Pages/CustomerSupport/FAQ';
// ===========================================================================================
// your orders
import YourOrders from '../Components/Pages/YourOrders/YourOrders';
import ShipmentDetails from '../Components/Pages/YourOrders/ShipmentDetails';
//--------------------------------------
import DeliveryDetails from '../Components/Pages/NominateRequest/DeliveryDetails';
import NominateRequestDetails from '../Components/Pages/NominateRequest/NominateRequestDetails';
//-------------
import RailQuotationHistory from '../Components/Pages/TFR/RailQuotationHistory';
import TerminalCreateRequest from '../Components/Pages/TFR/TerminalRequestService';
import TPTRequestHistory from '../Components/Pages/TerminalHandling/TPTRequestHistory';
import TPTRequestService from '../Components/Pages/TerminalHandling/TPTRequestService';
import TPTRequestDetails from '../Components/Pages/TerminalHandling/TPTRequestDetails';
//------------------------------------
//market place
import QuotationHistory from '../Components/Pages/MarketPlace/QuotationHistory';
import PaymentProcessTransportation from '../Components/Pages/MarketPlace/PaymentDetailsTransportation';
import QuotationContainerDetails from '../Components/Pages/MarketPlace/QuotationContainerDetails';
//import ContainerDetailsQuotation from '../Components/Pages/MarketPlace/ContainerDetailsQuotation';
import ViewPaymentDetails from '../Components/Pages/MarketPlace/ViewPaymentDetails';
import MyServicesSettings from '../Components/Pages/MarketPlace/MyServicesSettings';
import CreateServiceRequest from '../Components/Pages/MarketPlace/CreateServiceRequest';
import CreateTransportationService from '../Components/Pages/MarketPlace/CreateTransportationService';
import FilterRequests from '../Components/Pages/MarketPlace/FilterRequests';
import InvoiceDetails from '../Components/Pages/MarketPlace/InvoiceDetails';
import QuotationDetails from '../Components/Pages/MarketPlace/QuotationDetails';
import RespondentTransportationService from '../Components/Pages/MarketPlace/RespondentTransportationService';
import RespondentTSContainerDetails from '../Components/Pages/MarketPlace/RespondentTSContainerDetails';
//import ResponseContainerDetails from '../Components/Pages/MarketPlace/ResponseContainerDetails';
import ServiceRequest from '../Components/Pages/MarketPlace/ServiceRequest';
import ServiceSelection from '../Components/Pages/MarketPlace/ServiceSelection';
import ShipmentDetailsTransportationService from '../Components/Pages/MarketPlace/ShipmentDetailsTransportationService';
import UpdateServiceRequest from '../Components/Pages/MarketPlace/UpdateServiceRequest';
import TransportationService from '../Components/Pages/MarketPlace/TransportationService';
//------------------------
// Generic services
import CreateResponseForm from '../Components/Pages/GenericServices/CreateResponseForm';
//import UpdateResponseForm from '../Components/Pages/GenericServices/UpdateServiceRequestGS';
import QuotationHistoryGS from '../Components/Pages/GenericServices/QuotationHistoryGS';
import MarketPlacePaymentGS from '../Components/Pages/GenericServices/PaymentDetailsTransportationGS';
import ViewPaymentDetailsGS from '../Components/Pages/GenericServices/ViewPaymentDetailsGS';
import MyServicesSettingsGS from '../Components/Pages/GenericServices/MyServicesSettingsGS';
import CreateServiceRequestGS from '../Components/Pages/GenericServices/CreateServiceRequestGS';
import FilterRequestsGS from '../Components/Pages/GenericServices/FilterRequestsGS';
import InvoiceDetailsGS from '../Components/Pages/GenericServices/InvoiceDetailsGS';
import QuotationDetailsGS from '../Components/Pages/GenericServices/QuotationDetailsGS';
import RespondentTransportationServiceGS from '../Components/Pages/GenericServices/RespondentTransportationServiceGS';
import ServiceRequestGS from '../Components/Pages/GenericServices/ServiceRequestGS';
import ServiceSelectionGS from '../Components/Pages/GenericServices/ServiceSelectionGS';
import ShipmentDetailsTransportationServiceGS from '../Components/Pages/GenericServices/ShipmentDetailsTransportationServiceGS';
import UpdateServiceRequestGS from '../Components/Pages/GenericServices/UpdateServiceRequestGS';
import TransportationServiceGS from '../Components/Pages/GenericServices/TransportationServiceGS';
import Logout from '../Services/utils/Logout';

var interval = null;
var indexValue = 0;
class Layout extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      timeout: 120000,
      showModal: false,
      userLoggedIn: false,
      isTimedOut: false,
      //  hasOpenSession : false
      seconds: 60,
      changeSecondsColor: false,
      //   isActive: false,

      announcement: '',
      announcementDetails: '',
      announcementSettings: '',
      containerStatus: '',
      containerTrip: '',
      billOfLading: '',
      containerDetails: '',
      vesselDetail: '',
      preAdviceHome: '',
      PreAdviseDetails: '',
      nominateRequest: '',
      preferences: '',
      requestQuotation: '',
      submitRequest: '',
      requestTptQuotation: '',
      requestTPTDetails: '',
      requestTPTService: '',
      requestRailQuotation: '',
      requestTerminalService: '',
      truckAppointment: '',
      truckVisit: '',
      truckVisitsTrack: '',
      vesselStatus: '',
      vesselDetails: '',
      weather: '',
      companyInfo: '',
      bankInfo: '',
      driverProfile: ''
    }
    this.idleTimer = null
    this.onAction = this._onAction.bind(this)
    this.onActive = this._onActive.bind(this)
    this.onIdle = this._onIdle.bind(this)
    this.handleLogout = this.handleLogout.bind(this)
    this.onCloseModal = this.onCloseModal.bind(this)
  }
  _onAction(e) {
    //console.log('user did something', e)
    this.setState({ isTimedOut: false })
  }
  _onActive(e) {
    console.log('user is active', e)
    this.setState({ isTimedOut: false })
  }
  userLogout() {
    Logout();
  }
  _onIdle(e) {
    console.log('user is idle', e)
    const isTimedOut = this.state.isTimedOut
    if (isTimedOut) {
      this.userLogout();
    } else {
      // open modal and set Time
      this.setState({ showModal: true, seconds: 60 });
      // start timer
      // interval = null;
      clearInterval(interval);
      // if (this.state.seconds > 0) {
      interval = setInterval(() => {
        if (this.state.seconds > 0) {
          this.setState({ changeSecondsColor: false, seconds: this.state.seconds - 1 }
            , () => {
              // for change seconds color
              if (this.state.seconds < 10) {
                this.setState({ changeSecondsColor: true });
              }
              // for autometic logout
              if (this.state.seconds === 0 && this.state.showModal) {
                clearInterval(interval);
                this.userLogout();
              }
            }
          );
        }
        else {
          clearInterval(interval);
        }
      }, 1000);
      // }
      // if (this.state.seconds === 0) {
      //   //window.location.replace("/");
      //   console.log("in timer end");
      //   // setIsActive(true);
      // //  this.setState({isActive: true});
      // }
      return () => { clearInterval(interval) }
    }
  }
  handleLogout() {
    clearInterval(interval);
    this.setState({ showModal: false });
    this.userLogout();
  }
  onCloseModal() {
    clearInterval(interval);
    console.log("in close modal");
    this.setState({ timeout: 120000 });
    this.setState({ showModal: false });
    this.setState({ changeSecondsColor: false });
  }

  componentDidMount = () => {
    console.log("in layout.........")
    if (this.props.userProfileDataR?.profileRoles.length > 0) {
      // let previewIndex = this.props.manageProfileDataR?.selectedProfile;
      this.props.userProfileDataR?.profileRoles?.every((md, index) => {
        if (md.roleType.includes(this.props.manageProfileDataR?.selectedProfileType)) {
          //   previewIndex = index;
          indexValue = index;

          //   console.log('testinggggg', this.props.userProfileDataR?.profileRoles[previewIndex]?.permissions);

          return false
        }
        return true
      });


    }

    {

      this.props.userProfileDataR?.profileRoles[indexValue]?.permissions?.map((md, index) => {

        switch (md.functionId) {

          case 21:
            return this.setState({
              announcement: <Route path="/announcements" component={Announcement} />,
              //announcementDetails: 
              announcementSettings: <Route path="/announcement/notificationSettings" component={AnnouncementSetting} />
            });

          case 2:
            return this.setState({
              containerStatus: <Route path="/containerStatus" component={ContainerStatus} />,
              containerTrip: <Route path="/containerTrip/:containerNumber" component={ContainerStatusTripType} />,
              billOfLading: <Route path="/billOfLading/:billOfLadingNum" component={BillOfLading} />,
              vesselDetail: <Route path="/vesselDetail/:containerNumber/:tripType/:vesselInfo/:position" component={VesselDetail} />,
              containerDetails: <Route path="/containerDetails/:containerNumber/:tripType/:position" component={ContainerStatusView} />
            });

          case 3:
            return this.setState({
              containerStatus: <Route path="/containerStatus" component={ContainerStatus} />,
              containerTrip: <Route path="/containerTrip/:containerNumber" component={ContainerStatusTripType} />,
              billOfLading: <Route path="/billOfLading/:billOfLadingNum" component={BillOfLading} />,
              vesselDetail: <Route path="/vesselDetail/:containerNumber/:tripType/:vesselInfo/:position" component={VesselDetail} />,
              containerDetails: <Route path="/containerDetails/:containerNumber/:tripType/:position" component={ContainerStatusView} />
            })

          case 23:
            return this.setState({
              preAdviceHome: <Route path="/PreAdviseHome" component={PreAdviseHome} />,
              PreAdviseDetails: <Route path="/PreadviseDetails" component={PreadviseDetails} />
            });

          case 20:
            {
              if (this.props.manageProfileDataR?.selectedProfileType == "Requester") {
                return this.setState({
                  preferences: <Route path="/preferencesRequester" component={preferencesRequester} />
                })
              }
              else if (this.props.manageProfileDataR?.selectedProfileType == "Respondent") {
                return this.setState({
                  preferences: <Route path="/preferencesRespondent" component={preferencesRespondent} />
                });
              }
              else if (this.props.manageProfileDataR?.selectedProfileType ==  "Driver") {
                return this.setState({
                  preferences: <Route path="/preferencesDriver" component={preferencesDriver} />
                });
              }
              break;
            }

          case 28:
            return this.setState({
              requestQuotation: <Route path='/ServiceSelection' component={ServiceSelection} />
            });

          case 29:
            return this.setState({
              submitRequest: <Route path='/ServiceSelection' component={ServiceSelection} />
            });

          case 25:
            return this.setState({
              requestTptQuotation: <Route path='/TPTRequestHistory' component={TPTRequestHistory} />,
              requestTPTDetails: <Route path='/TPTRequestDetails/:orderId' component={TPTRequestDetails} />,
              requestTPTService: <Route path='/TPTRequestService' component={TPTRequestService} />
            });

          case 26:
            return this.setState({
              requestRailQuotation: <Route path='/RailQuotationHistory' component={RailQuotationHistory} />,
              requestTerminalService: <Route path='/TerminalRequestService' component={TerminalCreateRequest} />
            });
          case 8:
            return this.setState({
              truckAppointment: <Route path="/truckAppointment" component={TruckAppointment} />
            });

          case 9:
            return this.setState({
              truckVisit: <Route path="/truckVisit" component={TruckVisit} />,
              truckVisitsTrack: <Route path="/truckDetails/:truckNumber/:terminalName/:createdDate" component={TruckVisitsTrack} />
            });
          case 10:
            return this.setState({
              truckVisit: <Route path="/truckVisit" component={TruckVisit} />,
              truckVisitsTrack: <Route path="/truckDetails/:truckNumber/:terminalName/:createdDate" component={TruckVisitsTrack} />
            })

          case 6:
            return this.setState({
              vesselStatus: <Route path="/vessel" component={Vessel} />,
              vesselDetails: <Route path="/vesselDetails/:facilityCode/:vesselRefNbr" component={VesselDetail} />
            });

          case 7:
            return this.setState({
              vesselStatus: <Route path="/vessel" component={Vessel} />,
              vesselDetails: <Route path="/vesselDetails/:facilityCode/:vesselRefNbr" component={VesselDetail} />
            })
          case 4:
            return this.setState({
              weather: <Route path="/weatherInformation" component={WeatherInformation} />
            });

          default:
            break;

        }
      })
    }
    // if (this.props.userProfileDataR?.userMobile) {
      //localStorage.getItem('mobileVerificationDone') || this.props.userProfileDataR?.userMobile
    if (true) {
      this.setState({
        companyInfo: <Route path="/CompanyInfo/:roleId/:roleTypeValue/:roleNameValue/:profileTypeAndStatusValue" component={CompanyInfo} />,
        bankInfo: <Route path="/BankInfo/:roleId/:roleTypeValue/:roleNameValue/:profileTypeAndStatusValue" component={BankInfo} />,
        driverProfile: <Route path="/DriverProfile/:roleId/:roleTypeValue/:roleNameValue/:profileTypeAndStatusValue" component={DriverProfile} />
      })
    }

  }


  render() {
    // const { match } = this.props;
    return (
      <>
        <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={250}
          timeout={this.state.timeout}
        />
        <div>
          <Switch>
            {/* <Route path='/privateRoute' component={PrivateRoute}/> */}

            <Route path='/home' component={Home} />
            {this.state.announcement}
            <Route path="/announcementDetails/:announcementId" component={AnnouncementDetails} />
            {/* {this.state.announcementDetails} */}
            {this.state.announcementSettings}
            {/* <Route path="/announcements" component={Announcement} /> */}
            {/* <Route path="/announcementDetails/:announcementId" component={AnnouncementDetails} /> */}
            {/* <Route path="/announcement/notificationSettings" component={AnnouncementSetting} /> */}

            <Route path="/notification" component={Notification} />
            {this.state.vesselStatus}
            {this.state.vesselDetails}
            {/* <Route path="/vessel" component={Vessel} /> */}
            {/* <Route path="/vesselDetails/:facilityCode/:vesselRefNbr" component={VesselDetail} /> */}

            {this.state.weather}
            {/* <Route path="/weatherInformation" component={WeatherInformation} /> */}

            {this.state.containerStatus}
            {this.state.containerTrip}
            {this.state.billOfLading}
            {this.state.vesselDetail}
            {this.state.containerDetails}
            {/* <Route path="/containerStatus" component={ContainerStatus} /> */}
            {/* <Route path="/containerTrip/:containerNumber" component={ContainerStatusTripType} /> */}
            {/* <Route path="/billOfLading/:billOfLadingNum" component={BillOfLading} /> */}
            {/* <Route path="/vesselDetail/:containerNumber/:tripType/:vesselInfo/:position" component={VesselDetail} /> */}
            {/* <Route path="/containerDetails/:containerNumber/:tripType/:position" component={ContainerStatusView} /> */}


            <Route path="/ManageSubscription" component={ManageSubscription} />
            <Route path="/BrowseAllPlans" component={BrowseAllPlans} />
            <Route path="/paymentProcess/:planIdValue" component={paymentProcess} />
            <Route path="/paymentDetails/:orderId" component={PaymentDetails} />

            <Route path="/addProfile" component={AddProfile} />
            <Route path="/viewProfile/:roleId/:roleTypeValue/:roleNameValue/:profileTypeAndStatusValue" component={AddProfile} />
            {this.state.companyInfo}
            {this.state.bankInfo}
            {this.state.driverProfile}
            {/* <Route path="/CompanyInfo/:roleId/:roleTypeValue/:roleNameValue/:profileTypeAndStatusValue" component={CompanyInfo} /> */}
            {/* <Route path="/BankInfo/:roleId/:roleTypeValue/:roleNameValue/:profileTypeAndStatusValue" component={BankInfo} /> */}
            <Route path="/helloUser" component={ViewProfile} />
            <Route path="/verifyMobile/:roleId/:roleTypeValue/:roleNameValue/:profileTypeAndStatusValue/:nextPageValue" component={verifyMobile} />
            {/* <Route path="/DriverProfile/:roleId/:roleTypeValue/:roleNameValue/:profileTypeAndStatusValue" component={DriverProfile} /> */}
            <Route path="/profileActivity/:profileType" component={ProfileActivity} />

            {this.state.preferences}
            {/* <Route path="/preferencesRequester" component={preferencesRequester} />
            <Route path="/preferencesRespondent" component={preferencesRespondent} />
            <Route path="/preferencesDriver" component={preferencesDriver} /> */}

            <Route path="/CreateAppointment" component={CreateAppointment} />
            <Route path="/CreatePreadvise" component={CreatePreadvise} />
            {this.state.truckAppointment}
            {/* <Route path="/truckAppointment" component={TruckAppointment} /> */}
            <Route path="/AppointmentDetails/:appointmentNumber" component={AppointmentDetails} />

            <Route path="/CreatePreadviseDetails" component={CreatePreadviseDetails} />
            <Route path="/PreAdvise" component={PreAdvise} />
            <Route path="/AddReefer" component={AddReefer} />
            <Route path="/AddHazard" component={AddHazard} />
            {this.state.PreAdviseDetails}
            {/* <Route path="/PreadviseDetails" component={PreadviseDetails} /> */}
            <Route path="/CreateAddHazard" component={CreateAddHazard} />
            <Route path="/Placards" component={Placards} />
            <Route path="/OOGDetails" component={OOGDetails} />
            {this.state.truckVisit}
            {this.state.truckVisitsTrack}
            {/* <Route path="/truckDetails/:truckNumber/:terminalName/:createdDate" component={TruckVisitsTrack} /> */}
            {/* <Route path="/truckVisit" component={TruckVisit} /> */}
            <Route path="/PreadviseExcelDetails" component={PreadviseExcelDetails} />
            <Route path="/TrackHistoryforProxy" component={TrackHistoryforProxy} />
            <Route path="/PreadviseProxy" component={PreadviseProxy} />
            <Route path="/UploadPreadviseDocument" component={UploadPreadviseDocument} />
            <Route path="/TrackMultipleContainer" component={TrackMultipleContainer} />

            {this.state.preAdviceHome}
            {/* <Route path="/PreAdviseHome" component={PreAdviseHome} /> */}
            <Route path="/ContactUs" component={ContactUs} />
            <Route path="/AllQueries" component={AllQueries} />
            <Route path="/QueryDetails" component={QueryDetails} />
            <Route path="/RaiseQuery" component={RaiseQuery} />
            <Route path="/FAQ" component={FAQ} />
            <Route path='/YourOrders' component={YourOrders} />
            <Route path='/ShipmentDetails' component={ShipmentDetails} />
            <Route path='/DeliveryDetails' component={DeliveryDetails} />
            <Route path='/NominateRequestDetails' component={NominateRequestDetails} />

            {this.state.requestRailQuotation}
            {this.state.requestTerminalService}
            {/* <Route path='/RailQuotationHistory' component={RailQuotationHistory} /> */}
            {/* <Route path='/TerminalRequestService' component={TerminalCreateRequest} /> */}

            {this.state.requestTptQuotation}
            {this.state.requestTPTDetails}
            {this.state.requestTPTService}
            {/* <Route path='/TPTRequestHistory' component={TPTRequestHistory} /> */}
            {/* <Route path='/TPTRequestDetails/:orderId' component={TPTRequestDetails} /> */}
            {/* <Route path='/TPTRequestService' component={TPTRequestService} /> */}
            {/* MARKET PLACE */}
            <Route path='/QuotationHistory' component={QuotationHistory} />
            <Route path='/PaymentProcessTransportation/:serviceId' component={PaymentProcessTransportation} />
            {/* <Route path='/QuotationContainerDetails/:containerNo' component={QuotationContainerDetails} /> */}
            {/* <Route path='/ContainerDetailsQuotation' component={ContainerDetailsQuotation}/> */}
            <Route path='/ViewPaymentDetails' component={ViewPaymentDetails} />
            <Route path='/CreateServiceRequest/:serviceName' component={CreateServiceRequest} />
            <Route path='/CreateTransportationService/:serviceId/:serviceName' component={CreateTransportationService} />
            <Route path='/FilterRequests' component={FilterRequests} />
            <Route path='/InvoiceDetails' component={InvoiceDetails} />
            {/* <Route path='/ResponseContainerDetails' component={ResponseContainerDetails}/> */}
            {/* Submit Quotation tile click */}
            <Route path='/ServiceRequest' component={ServiceRequest} />
            <Route path='/ServiceRequestFilter/:policyName' component={ServiceRequest} />
            <Route path='/ShipmentDetailsTransportationService' component={ShipmentDetailsTransportationService} />
            <Route path='/QuotationDetails/:serviceId/:quotationId/:respondentId/:serviceName/:serviceStatus' component={QuotationDetails} />
            <Route path='/QuotationContainerDetails/:serviceId/:serviceName/:containerNo/:pickupLocation/:destination/:truckTypeRequirements'
             component={QuotationContainerDetails} />
              <Route path='/ViewQuotationContainerDetails/:serviceId'
             component={QuotationContainerDetails} />

            <Route path='/RespondentTransportationService/:type/:serviceRequestId/:serviceName' component={RespondentTransportationService} />
            <Route path='/RespondentTSContainerDetails' component={RespondentTSContainerDetails} />
            {/* Request Quotation tile click */}
            {this.state.requestQuotation}
            {/* <Route path='/ServiceSelection' component={ServiceSelection} /> */}
            <Route path='/UpdateServiceRequest/:serviceId/:serviceName' component={UpdateServiceRequest} />
            <Route path='/TransportationService/:serviceId/:serviceName' component={TransportationService} />
            <Route path='/MyServicesSettings' component={MyServicesSettings} />
            {/* GENERIC SERVICES */}
            <Route path='/QuotationHistoryGS' component={QuotationHistoryGS} />
            <Route path='/MarketPlacePaymentGS' component={MarketPlacePaymentGS} />
            <Route path='/ViewPaymentDetailsGS' component={ViewPaymentDetailsGS} />
            <Route path='/CreateServiceRequestGS' component={CreateServiceRequestGS} />
            <Route path='/FilterRequestsGS' component={FilterRequestsGS} />
            <Route path='/InvoiceDetailsGS' component={InvoiceDetailsGS} />
            <Route path='/QuotationDetailsGS/:serviceId/:quotationId/:respondentId/:serviceName/:serviceStatus' component={QuotationDetailsGS} />
            <Route path='/RespondentTransportationServiceGS/:type/:serviceRequestId/:serviceName' component={RespondentTransportationServiceGS} />
            <Route path='/ServiceRequestGS' component={ServiceRequestGS} />
            <Route path='/ServiceSelectionGS' component={ServiceSelectionGS} />
            <Route path='/ShipmentDetailsTransportationServiceGS' component={ShipmentDetailsTransportationServiceGS} />
            <Route path='/UpdateServiceRequestGS/:serviceId/:serviceName' component={UpdateServiceRequestGS} />
            <Route path='/TransportationServiceGS/:serviceId/:serviceName' component={TransportationServiceGS} />
            <Route path='/MyServicesSettingsGS' component={MyServicesSettingsGS} />
            <Route path='/CreateResponseForm/:serviceId/:serviceName' component={CreateResponseForm} />
            {/* <Route path='/UpdateResponseForm/:serviceId/:serviceName' component={UpdateResponseForm} /> */}
            <Route component={NotFound} />
          </Switch>
          <SessionExpire hasOpen={this.state.showModal} onCloseModal={this.onCloseModal} onYesModal={this.handleLogout}>
            <div>
              <div class="AccepttermscondiDivout">
                <small class="AccepttermscondiDivsmSS"> Your session is about to expire.</small>
                <div class="AccepttermscondiDivinSS">
                  <small class="AccepttermscondiDivinsmSS">You will be logged out in
                    {/* <small class="AccepttermscondiDivinsmtcOrange"> {this.state.seconds} </small> */}
                    <small class={this.state.changeSecondsColor ? "AccepttermscondiDivinsmtcOrange" : "AccepttermscondiDivinsmtcBlack"}> {this.state.seconds} </small>
                  seconds.
                  </small>
                </div>
              </div>
            </div>
          </SessionExpire>
        </div>
      </>
    );
  }
}
Layout.propTypes = {
  match: PropTypes.any.isRequired,
  history: PropTypes.func.isRequired
}
function mapStateToProps(state) {
  // debugger;
  if(state.userProfileInfoReducer.data){
  return {
    // loginDataR: JSON.parse(AES.decrypt(state.authentication.user, 'TPT_CARGO_CONNECT').toString(enc.Utf8)),
    //userProfileDataR: state.userProfileInfoReducer.data,
    manageProfileDataR: state.manageProfileReducer.data,
    userProfileDataR:JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8))
  }
}

}
export default connect(mapStateToProps)(Layout);